import React from "react";
import { FaStar } from "react-icons/fa";
const StarToggle = ({ isStarred, onToggle }) => (
  <span
    className={`star-beside ${isStarred ? "starred" : ""}`}
    onClick={e => { onToggle(); e.currentTarget.blur(); }}
    tabIndex={0}
    role="button"
    aria-pressed={isStarred}
    aria-label={isStarred ? "Unstar this recording" : "Star this for manager review"}
    title={isStarred ? "Unstar this recording" : "Star this for manager review"}
  >
    <FaStar />
  </span>
);
export default StarToggle;